import React from 'react';

const Vue_serverPrefetch = () => {
  return (
    <div>
      <h1>Vue_serverPrefetch Component</h1>
      <p>This is the Vue_serverPrefetch tutorial page.</p>
    </div>
  );
}

export default Vue_serverPrefetch;
